import {
  type ForecastTableControlValues,
  isEditableCalendarView
} from "../components/tableControls/forecastTableControlValues";

/** What the save gate reads off a forecast grid. */
export interface GridSaveState {
  /** Whether the rows the grid shows have loaded. */
  loaded: boolean;
  isSaving: boolean;
  isFetching: boolean;
  calendarView: ForecastTableControlValues["calendarView"];
}

/**
 * Returns whether a forecast grid's rows can be saved: loaded, idle, and on the
 * one view whose rows carry weekly cells; a save from a derived view would send
 * no cells.
 */
export function isGridSaveable({
  loaded,
  isSaving,
  isFetching,
  calendarView
}: GridSaveState): boolean {
  return (
    loaded && !isSaving && !isFetching && isEditableCalendarView(calendarView)
  );
}
